// import React, { useEffect, useState } from "react";
// import Modal from "react-modal";
// import Navbar from "../common/Navbar";
// import Footer from "../common/Footer";
// import Sidebar from "../common/Sidebar";
// import {
//   FiSend,
//   FiClock,
//   FiPaperclip,
//   FiChevronRight,
//   FiX,
// } from "react-icons/fi";
// import "./MySentMessages.css";

// const BASE_URL = process.env.REACT_APP_BASE_URL;

// const MySentMessages = () => {
//   const [messages, setMessages] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [selectedMessage, setSelectedMessage] = useState(null);

//   Modal.setAppElement("#root");

//   useEffect(() => {
//     const fetchMessages = async () => {
//       setLoading(true);
//       setError(null);

//       try {
//         const token = sessionStorage.getItem("token");

//         const response = await fetch(
//           `${BASE_URL}/api/mailmessage/getAllMessagesasSender`,
//           {
//             method: "GET",
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );

//         if (!response.ok) {
//           const errorData = await response.json();
//           throw new Error(errorData.message || "Failed to fetch messages");
//         }

//         const data = await response.json();
//         const sortedMessages = data.messages.sort(
//           (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
//         );
//         setMessages(sortedMessages);
//       } catch (error) {
//         console.error("Error fetching messages:", error);
//         setError(error.message || "Something went wrong");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchMessages();
//   }, []);

//   const handleReadMore = async (message) => {
//     if (!message.read) {
//       try {
//         const token = sessionStorage.getItem("token");
//         const response = await fetch(
//           `${BASE_URL}/api/mailmessage/updateReadStatus/${message._id}`,
//           {
//             method: "PATCH",
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );

//         if (!response.ok) {
//           throw new Error("Failed to update read status");
//         }

//         setMessages((prevMessages) =>
//           prevMessages.map((msg) =>
//             msg._id === message._id ? { ...msg, read: true } : msg
//           )
//         );
//       } catch (error) {
//         console.error("Error updating message read status:", error);
//       }
//     }

//     setSelectedMessage(message);
//     setIsModalOpen(true);
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//     setSelectedMessage(null);
//   };

//   if (loading) {
//     return (
//       <div className="sent-messages-loading">
//         <div className="sent-messages-spinner"></div>
//         <p>Loading your sent messages...</p>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="sent-messages-error">
//         <div className="sent-messages-error-icon">!</div>
//         <h3>Couldn't Load Messages</h3>
//         <p>{error}</p>
//         <button
//           className="sent-messages-retry-btn"
//           onClick={() => window.location.reload()}
//         >
//           Try Again
//         </button>
//       </div>
//     );
//   }

//   return (
//     <div className="sent-messages-page">
//       <Navbar />
//       <Sidebar />

//       <main className="sent-messages-main">
//         <div className="sent-messages-header">
//           <h1 className="sent-messages-title">
//             <FiSend className="sent-messages-icon" />
//             Sent Messages
//           </h1>
//           <div className="sent-messages-count">
//             {messages.length} {messages.length === 1 ? "Message" : "Messages"}
//           </div>
//         </div>

//         {messages.length === 0 ? (
//           <div className="sent-messages-empty">
//             <FiSend className="sent-messages-empty-icon" />
//             <h3>No Sent Messages</h3>
//             <p>Messages you send will appear here.</p>
//           </div>
//         ) : (
//           <div className="sent-messages-grid">
//             {messages.map((message) => (
//               <div
//                 key={message._id}
//                 className={`sent-message-card ${
//                   message.read ? "read" : "unread"
//                 }`}
//                 onClick={() => handleReadMore(message)}
//               >
//                 <div className="sent-message-recipient">
//                   To: {message.receiver ? message.receiver.name : "N/A"}
//                 </div>

//                 <h3 className="sent-message-subject">
//                   {message.subject || "No Subject"}
//                 </h3>

//                 <p className="sent-message-preview">
//                   {message.message.length > 120
//                     ? `${message.message.substring(0, 120)}...`
//                     : message.message}
//                 </p>

//                 <div className="sent-message-footer">
//                   <div className="sent-message-time">
//                     <FiClock className="time-icon" />
//                     {new Date(message.createdAt).toLocaleString("en-US", {
//                       month: "short",
//                       day: "numeric",
//                       hour: "2-digit",
//                       minute: "2-digit",
//                     })}
//                   </div>

//                   {message.files && message.files.length > 0 && (
//                     <div className="sent-message-attachments">
//                       <FiPaperclip className="attachment-icon" />
//                       {message.files.length}
//                     </div>
//                   )}
//                 </div>

//                 <div className="sent-message-view">
//                   View Details <FiChevronRight className="view-icon" />
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}
//       </main>

//       <Modal
//         isOpen={isModalOpen}
//         onRequestClose={closeModal}
//         contentLabel="Message Details"
//         className="sent-message-modal"
//         overlayClassName="sent-message-overlay"
//       >
//         <div className="sent-modal-content">
//           <button onClick={closeModal} className="sent-modal-close">
//             <FiX />
//           </button>

//           <h2 className="sent-modal-title">
//             <FiSend className="sent-modal-icon" />
//             Message Details
//           </h2>

//           <div className="sent-modal-details">
//             <div className="sent-modal-row">
//               <span className="sent-modal-label">To:</span>
//               <span className="sent-modal-value">
//                 {selectedMessage?.receiver
//                   ? selectedMessage.receiver.name
//                   : "N/A"}
//               </span>
//             </div>

//             <div className="sent-modal-row">
//               <span className="sent-modal-label">Subject:</span>
//               <span className="sent-modal-value">
//                 {selectedMessage?.subject || "No Subject"}
//               </span>
//             </div>

//             <div className="sent-modal-row full">
//               <span className="sent-modal-label">Message:</span>
//               <div className="sent-modal-message">
//                 {selectedMessage?.message}
//               </div>
//             </div>

//             <div className="sent-modal-row">
//               <span className="sent-modal-label">Sent:</span>
//               <span className="sent-modal-value">
//                 {selectedMessage &&
//                   new Date(selectedMessage.createdAt).toLocaleString()}
//               </span>
//             </div>

//             {selectedMessage?.files && selectedMessage.files.length > 0 && (
//               <div className="sent-modal-row full">
//                 <span className="sent-modal-label">Attachments:</span>
//                 <div className="sent-modal-attachments">
//                   {selectedMessage.files.map((file, index) => (
//                     <a
//                       key={index}
//                       href={file.url || file}
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="sent-modal-attachment"
//                     >
//                       <FiPaperclip className="attachment-icon" />
//                       {file.name || `Attachment ${index + 1}`}
//                     </a>
//                   ))}
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </Modal>

//       <Footer />
//     </div>
//   );
// };

// export default MySentMessages;



import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  CircularProgress,
  Grid,
  Paper,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Chip,
  Card,
  Stack,
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

// import { FiMail, FiChevronRight, FiPaperclip, FiClock } from "react-icons/fi";

import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import Sidebar from "../common/Sidebar";
import {
  FiSend,
  FiClock,
  FiPaperclip,
  FiChevronRight,
  FiX,
  FiMail,
} from "react-icons/fi";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const MySentMessages = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);

  useEffect(() => {
    const fetchMessages = async () => {
      setLoading(true);
      setError(null);

      try {
        const token = sessionStorage.getItem("token");

        const response = await fetch(
          `${BASE_URL}/api/mailmessage/getAllMessagesasSender`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || "Failed to fetch messages");
        }

        const data = await response.json();
        const sortedMessages = data.messages.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setMessages(sortedMessages);
      } catch (error) {
        console.error("Error fetching messages:", error);
        setError(error.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    fetchMessages();
  }, []);

  const handleReadMore = async (message) => {
    if (!message.read) {
      try {
        const token = sessionStorage.getItem("token");
        const response = await fetch(
          `${BASE_URL}/api/mailmessage/updateReadStatus/${message._id}`,
          {
            method: "PATCH",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to update read status");
        }

        setMessages((prevMessages) =>
          prevMessages.map((msg) =>
            msg._id === message._id ? { ...msg, read: true } : msg
          )
        );
      } catch (error) {
        console.error("Error updating message read status:", error);
      }
    }

    setSelectedMessage(message);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedMessage(null);
  };

  if (loading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="80vh"
      >
        <CircularProgress />
        <Typography mt={2}>Loading your sent messages...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box textAlign="center" mt={8}>
        <Typography variant="h6" color="error">
          Couldn't Load Messages
        </Typography>
        <Typography color="text.secondary" mt={1}>
          {error}
        </Typography>
        <Button
          variant="contained"
          sx={{ mt: 3 }}
          onClick={() => window.location.reload()}
        >
          Try Again
        </Button>
      </Box>
    );
  }

  return (
    <Box  sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        bgcolor: "#F8FAFC",
      }}
    >
      <Navbar />
      <Sidebar />


      <Box sx={{      p: { xs: 2, md: 3 }, ml: { md: "250px" } }}>
      <Box
  display="flex"
  flexDirection={{ xs: "column", sm: "row" }} // column on mobile, row on tablet+
  alignItems={{ xs: "flex-start", sm: "center" }}
  justifyContent="space-between"
  mb={3}
  mt={6}
  gap={{ xs: 2, sm: 0 }} // add space between on mobile
>
  {/* Left Section */}
  <Box>
    <Typography variant="h4" fontWeight="bold" display="flex" alignItems="center" gap={1}>
      <FiSend />
      Sent Messages
    </Typography>
    <Typography variant="subtitle1" color="text.secondary">
      View messages you have sent to others
    </Typography>
  </Box>

  {/* Right Section */}
  <Grid item xs={12} sm={6} md={3}>
    <Card
      sx={{
        borderRadius: 2,
        p: 1.5,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
        bgcolor: "white",
        width: { xs: "100%", sm: "auto" },
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: "2px" }}>
        <Typography
          sx={{
            fontSize: 12,
            fontWeight: 500,
            color: "#6b7280",
            lineHeight: 1.2,
          }}
        >
          Sent Messages
        </Typography>
        <Typography
          sx={{
            fontSize: 14,
            fontWeight: "bold",
            color: "#000",
            lineHeight: 1.3,
          }}
        >
          {messages.length} Sent{" "}
          {messages.length === 1 ? "Message" : "Messages"}
        </Typography>
      </Box>

      <Box
        sx={{
          backgroundColor: "#fef3c7",
          borderRadius: 2,
          p: 0.8,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          ml: 1.5,
        }}
      >
        <FiSend style={{ color: "#b45309", fontSize: 18 }} />
      </Box>
    </Card>
  </Grid>
</Box>


        {messages.length === 0 ? (
          <Box textAlign="center" py={8} mb={30}>
            <FiSend size={40} color="#aaa" />
            <Typography variant="h6" mt={2}>
              No Sent Messages
            </Typography>
            <Typography color="text.secondary">
              Messages you send will appear here.
            </Typography>
          </Box>
        ) : (
              <Box
                   sx={{
                     display: "grid",
                     width: "100%",
                     gridTemplateColumns: {
                       xs: "1fr",
                       sm: "repeat(auto-fit, minmax(280px, 1fr))", // flexible like in screenshot
                     },
                     gap: "20px", // consistent spacing between cards (both directions)
                     mb:30,
                   }}
                 >
            {messages.map((message) => (
              // <Grid item xs={12} sm={6} md={4} key={message._id}>
              //   <Paper
              //     elevation={3}
              //     sx={{
              //       p: 2,
              //       height: "100%",
              //       cursor: "pointer",
              //       borderLeft: message.read
              //         ? "5px solid transparent"
              //         : "5px solid #1976d2",
              //       "&:hover": {
              //         boxShadow: 6,
              //       },
              //     }}
              //     onClick={() => handleReadMore(message)}
              //   >
              //     <Typography variant="body2" color="text.secondary">
              //       To: {message.receiver ? message.receiver.name : "N/A"}
              //     </Typography>

              //     <Typography variant="h6" mt={1} fontWeight="bold">
              //       {message.subject || "No Subject"}
              //     </Typography>

              //     <Typography variant="body2" mt={1} sx={{ minHeight: "48px" }}>
              //       {message.message.length > 120
              //         ? `${message.message.substring(0, 120)}...`
              //         : message.message}
              //     </Typography>

              //     <Stack
              //       direction="row"
              //       justifyContent="space-between"
              //       alignItems="center"
              //       mt={2}
              //     >
              //       <Typography variant="caption" color="text.secondary" display="flex" alignItems="center" gap={0.5}>
              //         <FiClock />
              //         {new Date(message.createdAt).toLocaleString("en-US", {
              //           month: "short",
              //           day: "numeric",
              //           hour: "2-digit",
              //           minute: "2-digit",
              //         })}
              //       </Typography>

              //       {message.files && message.files.length > 0 && (
              //         <Typography
              //           variant="caption"
              //           display="flex"
              //           alignItems="center"
              //           gap={0.5}
              //         >
              //           <FiPaperclip />
              //           {message.files.length}
              //         </Typography>
              //       )}
              //     </Stack>

              //     <Divider sx={{ my: 2 }} />

              //     <Typography
              //       variant="body2"
              //       color="primary"
              //       display="flex"
              //       alignItems="center"
              //       gap={0.5}
              //     >
              //       View Details <FiChevronRight />
              //     </Typography>
              //   </Paper>
              // </Grid>
              <Grid item xs={12} sm={6} md={4} key={message._id}>
                <Box
                  onClick={() => handleReadMore(message)}
                  sx={{
                    p: { xs: 2, md: 3 },
                    cursor: "pointer",
                    position: "relative",
                    overflow: "hidden",
                    transition: "all 0.3s ease",
                    borderRadius: "16px",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12)",
                    height: 170,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    bgcolor: "#ffffff",
                    // borderLeft: message.read
                    //   ? "5px solid transparent"
                    //   : "5px solid #1976d2",
                    "&:hover": {
                      bgcolor: "#ffffff",
                      transform: "translateY(-1.5px)",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.18)",
                      "& .default-view": {
                        transform: "translateY(50px)",
                        opacity: 0,
                        transition: "transform 0.4s ease, opacity 0.4s ease",
                      },
                      "& .hover-view": {
                        transform: "translateY(0)",
                        opacity: 1,
                        transition: "transform 0.4s ease, opacity 0.4s ease",
                      },
                      "& .arrow-icon": {
                        transform: "rotate(0deg)",
                        transition: "transform 0.4s ease",
                      },
                    },
                  }}
                >
                  {/* Default View */}
                  <Box
                    className="default-view"
                    sx={{
                      width: "100%",
                      zIndex: 1,
                      flex: 1,
                      display: "flex",
                      p: 1,
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                      <FiMail style={{ fontSize: 18, color: "#1E40AF" }} />
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 700, color: "#1E293B",
                      fontSize: "1.1rem" // slightly smaller so the sentence fits nicely

                       }}
                    >
                      Message sent to:{" "}
                      <Box component="span" sx={{ color: "primary.main" }}>
                        {message.receiver ? message.receiver.name : "N/A"}
                      </Box>
                    </Typography>
       </Box>
                    {/* Subject line below */}
                    <Typography
                      sx={{
                        color: "#64748B",
                        fontSize: "0.95rem",
                        fontWeight: 500,
                        mt: 0.3
                      }}
                    >
                      {message.subject
                        ?.split(" ") // split into words
                        .slice(0, 15) // take first 25 words
                        .join(" ") + (message.subject?.split(" ").length > 15 ? "..." : "")}
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        color: "#000000",
                        fontWeight: 600,
                        fontSize: "0.8rem",
                        mt: "auto",
                      }}
                    >
                      <FiClock style={{ marginRight: 5, fontSize: 14 }} />
                      {new Date(message.createdAt).toLocaleString("en-US", {
                        month: "short",
                        day: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </Box>
                  </Box>

                  {/* Hover View */}
                  <Box
                    className="hover-view"
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      opacity: 0,
                      transform: "translateY(-30px)",
                      transition: "transform 0.4s ease, opacity 0.4s ease",
                      overflowY: "auto",
                      p: { xs: 2, md: 4 },
                      pb: 6,
                      pr: 1,
                      "&::-webkit-scrollbar": { width: "5px" },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "#b0b0b0",
                        borderRadius: "10px",
                      },
                      "&::-webkit-scrollbar-thumb:hover": {
                        backgroundColor: "#999",
                      },
                      "&::-webkit-scrollbar-track": {
                        backgroundColor: "transparent",
                      },
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#000000",
                        fontWeight: 400,
                        fontSize: "0.95rem",
                        lineHeight: 1.5,
                        whiteSpace: "pre-wrap",
                      }}
                    >
                      {message.message}
                    </Typography>
                  </Box>

                  {/* Arrow Icon */}
                  <Box
                    className="arrow-icon"
                    sx={{
                      position: "absolute",
                      bottom: 16,
                      right: 16,
                      transform: "rotate(45deg)",
                      transition: "transform 0.4s ease",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="28"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#1E40AF"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <line x1="5" y1="12" x2="19" y2="12" />
                      <polyline points="12 5 19 12 12 19" />
                    </svg>
                  </Box>
                </Box>
              </Grid>

            ))}
        </Box>
        )}
      </Box>

      {/* MUI Dialog for Modal */}
<Dialog
  open={isModalOpen}
  onClose={closeModal}
  PaperProps={{
    sx: {
      backgroundColor: "#fff",
      borderRadius: 2,
      width: "80vw",        // fixed width relative to screen
      maxWidth: 800,        // cap max width
      minWidth: 400,
      maxHeight: "80vh",    // limit height
      display: "flex",
      flexDirection: "column",
      p: 3,
      position: "relative",
      boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
    },
  }}
>

  <button
  onClick={closeModal}
  style={{
    position: "absolute",
    // top: "8px",
    // right: "17px"
    // ,
    marginLeft:"340px",
    marginBottom:"10px",
    marginTop:0,

    color: "black",
    background: "transparent",
    border: "none",
    cursor: "pointer",
    padding: "4px",
    borderRadius: "50%",
  }}

>
   
    <CloseIcon />
 
</button>

  {/* Title */}
  <Typography variant="h6" sx={{ mb: 2, display: "flex", alignItems: "center", gap: 1 }}>
    <FiSend /> Message Details
  </Typography>





  {/* Scrollable Content */}
  <Box sx={{ overflowY: "auto", pr: 1, flex: 1 }}>
    <Typography variant="subtitle2" color="text.secondary">To:</Typography>
    <Typography mb={2}>
      {selectedMessage?.receiver ? selectedMessage.receiver.name : "N/A"}
    </Typography>

    <Typography variant="subtitle2" color="text.secondary">Subject:</Typography>
    <Typography mb={2}>{selectedMessage?.subject || "No Subject"}</Typography>

    <Typography variant="subtitle2" color="text.secondary">Message:</Typography>
    <Typography mb={2} sx={{ whiteSpace: "pre-wrap" }}>
      {selectedMessage?.message}
    </Typography>

    <Typography variant="subtitle2" color="text.secondary">Sent:</Typography>
    <Typography mb={2}>
      {selectedMessage && new Date(selectedMessage.createdAt).toLocaleString()}
    </Typography>

    {/* Attachments */}
    {selectedMessage?.files && selectedMessage.files.length > 0 && (
      <>
        <Typography variant="subtitle2" color="text.secondary">Attachments:</Typography>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mt: 1 }}>
          {selectedMessage.files.map((file, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                width: 100,
              }}
            >
              {/\.(jpg|jpeg|png|gif)$/i.test(file.url || file) ? (
                <Box
                  component="img"
                  src={file.url || file}
                  alt={file.name || `Attachment ${index + 1}`}
                  sx={{
                    width: "100%",
                    height: "auto",
                    borderRadius: 1,
                    mb: 0.5,
                    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                  }}
                />
              ) : (
                <Box sx={{ fontSize: 24, mb: 0.5 }}>📄</Box>
              )}
              <Typography
                component="a"
                href={file.url || file}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: "primary.main",
                  textDecoration: "none",
                  fontSize: "0.85rem",
                  "&:hover": { textDecoration: "underline" },
                }}
              >
                {file.name || `Attachment ${index + 1}`}
              </Typography>
            </Box>
          ))}
        </Box>
      </>
    )}
  </Box>
</Dialog>


      <Footer />
    </Box>
  );
};

export default MySentMessages;
